import { axiosInstance } from "./axiosInstance";

// 1. 주문 목록 조회
export const getAdminOrders = async (params: { searchKeyword?: string; orderStatus?: string; paymentMethod?: string; page?: number; size?: number }) => {
    try {
        const response = await axiosInstance.get(`/api/admin/orders`, { params });
        return response.data;
    } catch (error) {
        console.error("주문 목록 조회 에러:", error);
        throw error;
    }
};

// 2. 주문 상세 조회 (마스터 + 상품 목록)
export const getAdminOrderDetail = async (orderId: string | number) => {
    try {
        const response = await axiosInstance.get(`/api/admin/orders/${orderId}`);
        return response.data;
    } catch (error) {
        console.error("주문 상세 조회 에러:", error);
        throw error;
    }
};

// 3. 주문 상태 변경
export const updateAdminOrderStatus = async (orderId: string | number, orderStatus: string) => {
    try {
        const response = await axiosInstance.patch(`/api/admin/orders/${orderId}/status`, { orderStatus });
        return response.data;
    } catch (error) {
        console.error("주문 상태 변경 에러:", error);
        throw error;
    }
};